export const enableAutomation = async (sendAndWaitWs, automationId) => {
  const request = { automationId };
  const response = await sendAndWaitWs(
    "/automation/enable",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const disableAutomation = async (sendAndWaitWs, automationId) => {
  const request = { automationId };
  const response = await sendAndWaitWs(
    "/automation/disable",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const runningAutomation = async (sendAndWaitWs, automationId) => {
  const request = {
    automationId,
    sideData: {
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      locationSymbol: "Local",
    },
  };
  const response = await sendAndWaitWs(
    "/automation/run",
    JSON.stringify(request)
  );
  if (response.error) {
    return false;
  }
  const jsonData = JSON.parse(response.payload);
  return jsonData && jsonData.success;
};

export const deleteAutomation = async (
  sendAndWaitWs,
  automationId,
  force = false
) => {
  const request = { automationId, force };
  const response = await sendAndWaitWs(
    "/automation/delete",
    JSON.stringify(request)
  );
  if (response.error) {
    return false;
  }
  const jsonData = JSON.parse(response.payload);
  return jsonData && jsonData.success;
};

export const listAutomations = async (sendAndWaitWs, cycle, type = null) => {
  const request = { cycle };
  if (type !== null) {
    request.type = type;
  }
  const response = await sendAndWaitWs(
    "/automation/list",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const listAutomationsByCard = async (sendAndWaitWs, cardId) => {
  const request = { cardId };
  const response = await sendAndWaitWs(
    "/automation/listByCard",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const getAutomationCardInfo = async (sendAndWaitWs, automationId) => {
  const request = { automationId };
  const response = await sendAndWaitWs(
    "/automation/card/get",
    JSON.stringify(request)
  );
  if (response.error) {
    return null;
  }
  return JSON.parse(response.payload);
};

export const initAutomationEditing = async (
  sendAndWaitWs,
  automationId,
  inspireId,
  inspireVersion,
  scriptId,
  args
) => {
  const request = {};
  if (inspireId) {
    request.inspireId = inspireId;
    request.inspireVersion = inspireVersion;
    if (args) {
      request.args = args;
    }
  } else if (automationId || scriptId) {
    if (automationId) {
      request.automationId = automationId;
    }
    if (scriptId) {
      request.scriptId = scriptId;
    }
  } else {
    return null;
  }

  const response = await sendAndWaitWs(
    "/automation/overview/init",
    JSON.stringify(request)
  );
  if (response.error) {
    return null;
  }
  return JSON.parse(response.payload);
};

export const getAutomationInfo = async (sendAndWaitWs, automationId) => {
  const request = { automationId };
  const response = await sendAndWaitWs(
    "/automation/info",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const batchGetAutomationNames = async (sendAndWaitWs, automationIds) => {
  const request = { automationIds };
  const response = await sendAndWaitWs(
    "/automation/names",
    JSON.stringify(request)
  );
  if (response.error) {
    return null;
  }
  return JSON.parse(response.payload);
};

export const getAutomation = async (
  sendAndWaitWs,
  automationId,
  includeScript = false
) => {
  const request = { automationId, includeScript };
  const response = await sendAndWaitWs(
    "/automation/get",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const getAutomationDraft = async (
  sendAndWaitWs,
  scriptId,
  includeScript = false
) => {
  const request = { scriptId, includeScript };
  const response = await sendAndWaitWs(
    "/automation/draft/get",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const formatAutomation = async (sendAndWaitWs, script) => {
  const request = { script };
  const response = await sendAndWaitWs(
    "/automation/format",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const copyAutomation = async (sendAndWaitWs, automationId, name) => {
  const request = { automationId, name };
  const response = await sendAndWaitWs(
    "/automation/copy",
    JSON.stringify(request)
  );
  if (response.error) {
    return null;
  }
  return JSON.parse(response.payload);
};

export const enrollAutomation = async (sendAndWaitWs, automationId, name) => {
  const request = { automationId, name };
  const response = await sendAndWaitWs(
    "/automation/enroll",
    JSON.stringify(request)
  );
  if (response.error) {
    return null;
  }
  return JSON.parse(response.payload);
};

export const saveAutomationScript = async (
  sendAndWaitWs,
  script,
  automationId = null,
  debug = false
) => {
  const request = {
    script,
    debug,
  };
  if (automationId) {
    request["automationId"] = automationId;
  }
  const response = await sendAndWaitWs(
    "/automation/save",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const saveAutomationName = async (
  sendAndWaitWs,
  automationId,
  automationName
) => {
  const request = {
    automationId,
    preferredName: automationName,
  };
  const response = await sendAndWaitWs(
    "/automation/save",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const getDebugInfo = async (apiCall, scopeId, automationId) => {
  return await apiCall(
    `/automation/debug?tenant=mlink&id=${automationId}`,
    "POST",
    { tenantId: "mlink", scopeId, automationId },
    null,
    "admin"
  );
};

export const batchDelete = async (sendAndWaitWs, automationIds, force) => {
  const request = { automationIds, force };
  const response = await sendAndWaitWs(
    "/automation/batchDelete",
    JSON.stringify(request)
  );
  if (response.error) {
    return false;
  }
  const jsonData = JSON.parse(response.payload);
  return jsonData && jsonData.success;
};

export const batchDeleteDraft = async (sendAndWaitWs, scriptIds) => {
  const request = { scriptIds };
  const response = await sendAndWaitWs(
    "/automation/draft/batchDelete",
    JSON.stringify(request)
  );
  if (response.error) {
    return false;
  }
  const jsonData = JSON.parse(response.payload);
  return jsonData && jsonData.success;
};

export const shareAutomation = async (sendAndWaitWs, automationId) => {
  const request = { automationId };
  const response = await sendAndWaitWs(
    "/automation/share",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const getAutomationStatus = async (sendAndWaitWs, automationId) => {
  const request = { automationId };
  const response = await sendAndWaitWs(
    "/automation/status",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const getEntityAutomationRelations = async (
  sendAndWaitWs,
  entityType,
  integration,
  entityId,
  filter = null
) => {
  const requestData = {
    entityType,
    integration,
    entityId,
    allCapability: filter?.allCapability || [],
    anyCapability: filter?.anyCapability || [],
  };

  const response = await sendAndWaitWs(
    "/kg/entityAutomationRelation/get",
    JSON.stringify(requestData)
  );
  if (response.error) {
    console.error(
      "Error fetching entity automation relations:",
      response.error
    );
    return null;
  }
  return JSON.parse(response.payload);
};

export const getHistory = async (
  sendAndWaitWs,
  automationId,
  size,
  token,
  filterTimestamp
) => {
  const request = { automationId, size };
  if (token) {
    request.nextToken = token;
  }
  if (filterTimestamp) {
    request.timestamp = filterTimestamp;
  }
  const response = await sendAndWaitWs(
    "/automation/history/get",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const getHistoryList = async (
  sendAndWaitWs,
  size,
  token,
  filterTimestamp
) => {
  const request = { size };
  if (token) {
    request.nextToken = token;
  }
  if (filterTimestamp) {
    request.timestamp = filterTimestamp;
  }
  const response = await sendAndWaitWs(
    "/automation/history/list",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const updateAutomationConfig = async (
  sendAndWaitWs,
  sessionId,
  varData
) => {
  const request = { ...varData, sessionId };
  const response = await sendAndWaitWs(
    "/automation/overview/updateConfig",
    JSON.stringify(request)
  );
  if (response.error) {
    return { error: response.error };
  }
  return JSON.parse(response.payload);
};

export const provideAutomationConfig = async (
  sendAndWaitWs,
  sessionId,
  varData
) => {
  const request = { ...varData, sessionId };
  const response = await sendAndWaitWs(
    "/automation/overview/provideConfig",
    JSON.stringify(request)
  );
  if (response.error) {
    return { error: response.error };
  }
  return JSON.parse(response.payload);
};

export const saveAutomationOverview = async (
  sendAndWaitWs,
  sessionId,
  params
) => {
  const request = { sessionId, ...params };
  const response = await sendAndWaitWs(
    "/automation/overview/save",
    JSON.stringify(request)
  );
  if (response.error) {
    return { error: response.error };
  }
  return JSON.parse(response.payload);
};

export const cancelAutomationEditing = async (sendAndWaitWs, sessionId) => {
  const request = { sessionId };
  await sendAndWaitWs("/automation/overview/cancel", JSON.stringify(request));
};

export const getAutomationExecution = async (
  sendAndWaitWs,
  automationId,
  startTime,
  endTime
) => {
  const request = { automationId, startTime, endTime };
  const response = await sendAndWaitWs(
    "/automation/execution/get",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};
